module.exports = __webpack_public_path__ + "img/44.ca399868.png";